<template>
  <div class="settings-page">
    <!-- SIDEBAR -->
    <div class="settings-sidebar">
      <ul>
        <li :class="{ active: tab === 'general' }" @click="tab = 'general'">
          ⚙️ Chung
        </li>
        <li :class="{ active: tab === 'company' }" @click="tab = 'company'">
          🏢 Doanh nghiệp
        </li>
        <li :class="{ active: tab === 'invoice' }" @click="tab = 'invoice'">
          🧾 Hoá đơn
        </li>
        <li :class="{ active: tab === 'email' }" @click="tab = 'email'">
          📧 Email
        </li>
        <li :class="{ active: tab === 'security' }" @click="tab = 'security'">
          🔐 Bảo mật
        </li>
      </ul>
    </div>

    <!-- CONTENT -->
    <div class="settings-content">
      <!-- GENERAL -->
      <div v-if="tab === 'general'" class="card">
        <h3>Cài đặt chung</h3>

        <div class="form-group">
          <label>Ngôn ngữ</label>
          <select v-model="form.language">
            <option value="vi">Tiếng Việt</option>
            <option value="en">English</option>
          </select>
        </div>

        <div class="form-group">
          <label>Múi giờ</label>
          <select v-model="form.timezone">
            <option value="Asia/Ho_Chi_Minh">GMT+7</option>
          </select>
        </div>
      </div>

      <!-- COMPANY -->
      <div v-if="tab === 'company'" class="card">
        <h3>Thông tin doanh nghiệp</h3>

        <div class="form-group">
          <label>Tên công ty</label>
          <input v-model="form.company_name" />
        </div>

        <div class="form-group">
          <label>Địa chỉ</label>
          <input v-model="form.address" />
        </div>

        <div class="form-group">
          <label>Điện thoại</label>
          <input v-model="form.phone" />
        </div>
      </div>

      <!-- INVOICE -->
      <div v-if="tab === 'invoice'" class="card">
        <h3>Cài đặt hoá đơn</h3>

        <div class="form-group">
          <label>Tiền tệ</label>
          <select v-model="form.currency">
            <option value="VND">VND</option>
            <option value="USD">USD</option>
          </select>
        </div>

        <div class="form-group">
          <label>Thuế (%)</label>
          <input type="number" v-model="form.tax" />
        </div>
      </div>

      <!-- EMAIL -->
      <div v-if="tab === 'email'" class="card">
        <h3>Cấu hình Email</h3>

        <div class="form-group">
          <label>SMTP Host</label>
          <input v-model="form.smtp_host" />
        </div>

        <div class="form-group">
          <label>Email</label>
          <input v-model="form.smtp_email" />
        </div>
      </div>

      <!-- SECURITY -->
      <div v-if="tab === 'security'" class="card">
        <h3>Bảo mật</h3>

        <div class="form-group">
          <label>Đổi mật khẩu</label>
          <input type="password" v-model="form.password" />
        </div>
      </div>

      <!-- ACTION -->
      <div class="actions">
        <button class="btn-save" @click="saveSettings">Lưu</button>
        <button class="btn-cancel" @click="resetForm">Huỷ</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
import { ref } from "vue";

const tab = ref("general");
const toast = useToast();
const form = ref({
  language: "vi",
  timezone: "Asia/Ho_Chi_Minh",
  company_name: "",
  address: "",
  phone: "",
  currency: "VND",
  tax: 0,
  smtp_host: "",
  smtp_email: "",
  password: "",
});

const saveSettings = () => {
    toast.success("Cài đặt đã được lưu thành công!");
  //   try {
  //     await axios.post("/api/settings", form.value);
  //     alert("Lưu thành công!");
  //   } catch (error) {
  //     console.error(error);
  //   }
    
};

const resetForm = () => {
  location.reload();
};
</script>
<style scoped>
.settings-page {
  display: flex;
  height: 100%;
}

.settings-sidebar {
  width: 220px;
  background: #2c3e50;
  color: #fff;
}

.settings-sidebar ul {
  list-style: none;
  padding: 0;
}

.settings-sidebar li {
  padding: 12px;
  cursor: pointer;
}

.settings-sidebar li.active {
  background: #42b983;
}

.settings-content {
  flex: 1;
  padding: 20px;
}

.card {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  display: block;
  margin-bottom: 4px;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
}

.actions {
  display: flex;
  gap: 10px;
}

.btn-save {
  background: #42b983;
  color: #fff;
  padding: 8px 16px;
}

.btn-cancel {
  background: #ccc;
  padding: 8px 16px;
}</style>
